<template>
    <div
      :id="id"
      :class="className"
      :style="{height: height, width: width}"
    />
</template>

<script lang="ts">
import {
  defineComponent,
  onActivated,
  onBeforeUnmount,
  onDeactivated,
  onMounted,
  nextTick,
  watch
} from 'vue'
import resize from '@/components/charts/mixins/resize'
import { init, EChartsOption } from 'echarts'
export default defineComponent({
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    id: {
      type: String,
      default: 'lineChartsCompoents'
    },
    width: {
      type: String,
      default: '100%',
      required: true
    },
    height: {
      type: String,
      default: '350px',
      required: true
    },
    chartData: {
      type: Object,
      default: {}
    },
    selectedTime: {
      type: String || Number,
      default: ''
    },
  },
  setup(props, context) {
    const {
      mounted,
      chart,
      beforeDestroy,
      activated,
      deactivated
    } = resize()

    watch(props, (newName, oldName) => {
      initChart()
    });

    const initChart = () => {
      const xAxisList = Array.from(props.chartData.list, ({ formatDate }) => formatDate);
      const yAxisLeftList = Array.from(props.chartData.list, ({ shIndex }) => shIndex);
      const compositeIndex = yAxisLeftList.filter((item) => item !== null);
      const MaxArrpLeft = Math.ceil(Math.max(...compositeIndex));
      const MinArrpLeft = Math.floor(Math.min(...compositeIndex));
      const yAxisRightList = Array.from(props.chartData.list, ({ bx }) => bx);
      const timeLeft = xAxisList.sort()[0]
      const timeCenter = xAxisList.sort()[10]
      const timeRight = xAxisList.sort()[xAxisList.length -1]
      const integerData: any = [];
      yAxisRightList.map((item) => {
        let obj = {
          value: item,
          itemStyle: {
            color: item > 0 ? '#F74E4F' : '#5CBC7C'
          }
        }
        integerData.push(obj)
      })
      const iconUrl = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAHCAYAAAFy0i3pAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEqADAAQAAAABAAAABwAAAAAyqaqnAAAAR0lEQVQoFWNgwAYYY/bU/AdJLHFpYfzu5w9mYyiEq5o96TJYEi4AU4pXO0wR2TRR1jGRbTzNNGK4G90mULCBxHCGPLoGSvkA1Yoe51xpxlAAAAAASUVORK5CYII='
      const MaxArrpRight = Math.ceil(Math.max(...yAxisRightList));
      const MinArrpRight = Math.floor(Math.min(...yAxisRightList));
      context.emit('getbxVal', {MinArrpLeft, MaxArrpLeft, MaxArrpRight, MinArrpRight, timeLeft, timeCenter, timeRight})
      const barChart = init(document.getElementById(props.id) as HTMLDivElement)
      barChart.setOption({
        grid: {
          top: '20px',
          left: '0',
          right: '0%',
          bottom: '100px',
          containLabel: true
        },
        legend: {
          icon: 'line',
          itemWidth: 12,  // 设置宽度
          itemHeight: 6, // 设置高度
          x: 'center',
          bottom: '0',
          itemGap: 30,
          textStyle: {
            fontSize: 12,// 字体大小
            color:'#666666',
          },
          data: [
            {
              name: '上证指数',
            },
            {
              name: '北上净买入(亿元)',
              icon: iconUrl,
            }
          ]
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        xAxis: {
          data: xAxisList,
          axisLine: { show: false, onZero: false },
          splitLine: { show: false },
          axisLabel:{ show: false },
          axisTick: { show: false },
          splitArea: { show: false }
        },
        yAxis: [
          {
            type: 'value',
            splitLine: { show: false },
            max: MaxArrpLeft,
            min: MinArrpLeft,
            axisPointer: {
              type: 'none',
              label: { show: false }
            },
            axisLabel: {
              show: false,
              align: 'right',
            }
          },
          {
            type: 'value',
            splitLine: { show: true, lineStyle: { type: 'dashed' } },
            axisLabel: {
              show: false,
            }
          }
        ],
        series: [
          {
            name: '上证指数',
            type: 'line',
            yAxisIndex: 0,
            symbol: 'none',
            itemStyle: {
              normal: {
                lineStyle: {
                  width: 1.5,
                  color: '#0086FB'
                },
              }
            },
            data: compositeIndex
          },
          {
            name: '北上净买入(亿元)',
            type: 'bar',
            yAxisIndex: 1,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: '#F74E4F',
                label:{
                  show: true,
                  position: 'top',
                  textStyle: {
                    fontSize: '12',
                  }
                }
              },
            },
            data: integerData
          },
        ]
      } as EChartsOption)
      chart.value = barChart
    }

    onMounted(() => {
      mounted()
      nextTick(() => {
        initChart()
      })
    })

    onBeforeUnmount(() => {
      beforeDestroy()
    })

    onActivated(() => {
      activated()
    })

    onDeactivated(() => {
      deactivated()
    })

    return {
    }
  }
})
</script>
